import { parseExtraValues } from "./extraValues";

/**
 * Is this bowler linked to a customer of the pro shop's SpectrePOS, and what
 * does the shop call them?
 *
 * Two shapes live in `extra_values.pos`, one per kind of shop:
 *   - WordPress: { customer_id: <WooCommerce user id> }
 *   - HBS:       { backend: "hbs", shop_customer_id: <uuid>, code: <shop code> }
 *
 * Returns what to show after "SpectrePOS customer #", or null when unlinked.
 */
export const posLinkLabel = (rawExtraValues) => {
  const pos = parseExtraValues(rawExtraValues).pos;
  if (!pos) return null;
  if (pos.backend === "hbs") {
    return pos.shop_customer_id ? String(pos.code || pos.shop_customer_id) : null;
  }
  const cid = parseInt(pos.customer_id, 10);
  return cid > 0 ? cid : null;
};
